

if (!customElements.get('instagram-slider')) {
    customElements.define('instagram-slider',
        class ProductInfo extends HTMLElement {
            connectedCallback() {
                this.style.visibility = "visible"
                var dots = this.dataset.dots && this.dataset.dots == "true" ? true : false;
                var arrows = this.dataset.arrows && this.dataset.arrows == "false" ? false : true;

                if ($(this).find('.slick-ins').children().length && $(this).find('.slick-ins').children().length <= 4 && !dots) {
                    $(this).find('.slick-ins').children().clone(true, true).appendTo($(this).find('.slick-ins'));
                }

                let isAutoplay = this.dataset.autoplay == "true";
                let autoplaySpeed = parseInt(this.dataset.autoplay_speed) || 3;
                autoplaySpeed *= 1000;

                let mobileShow = parseInt(this.dataset.mobile_show) || 2;
                let desktop_show = parseInt(this.dataset.desktop_show) || 3;

                let breakpoint = [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: mobileShow,
                        },
                    },
                ];
                if (mobileShow == 1) {
                    $(this).find('.slick-ins').addClass('has-padding-mobile');
                    breakpoint = [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: mobileShow,
                                centerMode: true,
                            },
                        },
                    ];
                }
                var currentSlide = $(this).find('.slick-ins').slick({
                    slidesToShow: desktop_show,
                    slidesToScroll: 1,
                    autoplay: isAutoplay,
                    autoplaySpeed: autoplaySpeed,
                    infinite: true,
                    arrows: false,
                    responsive: breakpoint,
                    dots: false
                });

                $(this).find('.button-prev').click(function () {
                    currentSlide.slick('slickPrev')
                });
                $(this).find('.button-next').click(function () {
                    currentSlide.slick('slickNext')
                })


            }
        }
    )
}

